/* Runde 2 (06.10. abends): Ersparnis je Stufe statt Stueckpreis, Murphy-Zeile nur in upsell.show_on_bars, Regel-Pille optional.
   Restwick Kids (06.10.2026): Kaufblock 100,000 Whys mit Gratisbuch-Auswahl, Murphy- und Gift-wrap-Checkbox.
   Galerie und Bestandszaehler kommen aus rw.js (gleiche Data-Attribute). Warenkorb wie Restwick: leeren, hinzufuegen, Side-Drawer. */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents, cur) {
    const v = cents / 100;
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur || 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v); }
    catch (e) { return '$' + v.toFixed(2); }
  }

  $$('[data-rwk-buy]').forEach(box => {
    const cfg = JSON.parse($('[data-rwk-cfg]', box).textContent);
    const tiers = $$('[data-rwk-tier]', box), gifts = $$('[data-rwk-gift]', box);
    const booksBox = $('[data-rwk-books]', box), books = $$('[data-rwk-book]', box);
    const ups = $('[data-rwk-ups]', box), upsRow = $('[data-rwk-ups-row]', box), wrap = $('[data-rwk-wrap]', box), wrapRow = $('[data-rwk-wrap-row]', box);
    const cta = $('[data-rwk-cta]', box);
    let cur = tiers.find(t => t.classList.contains('is-on')) || tiers[0];
    let picks = [];

    /* Paketpreis je Stufe aus den Varianten: 1 = Single, 2 = 2x Bundle, 3+ = 1x Single + Rest Gift Pack */
    const lineItems = main => main <= 1 ? [[cfg.single, 1, cfg.singlePrice]]
      : main === 2 && cfg.bundle ? [[cfg.bundle, 2, cfg.bundlePrice]]
      : cfg.gift ? [[cfg.single, 1, cfg.singlePrice], [cfg.gift, main - 1, cfg.giftPrice]]
      : [[cfg.single, main, cfg.singlePrice]];
    const totalOf = main => lineItems(main).reduce((s, l) => s + l[1] * l[2], 0);
    const lvlOf = t => tiers.indexOf(t) + 1;
    const wrapInc = lvl => Array.isArray(cfg.wrapIncBars) && cfg.wrapIncBars.indexOf(lvl) > -1;

    tiers.forEach(t => {
      const qty = +t.dataset.qty, main = +t.dataset.main, free = +t.dataset.free, lvl = lvlOf(t);
      const total = totalOf(main);
      const compare = cfg.compare * main + cfg.bookPrice * free + (wrapInc(lvl) ? cfg.wrapPrice : 0);
      $('[data-rwk-total]', t).textContent = money(total, cfg.currency);
      $('[data-rwk-cmp]', t).textContent = compare > total ? money(compare, cfg.currency) : '';
      const each = $('[data-rwk-each]', t); if (each) each.textContent = qty > 1 && cfg.each ? money(Math.round(total / qty), cfg.currency) + ' ' + cfg.each : '';
      const sv = $('[data-rwk-save]', t); if (sv) sv.textContent = compare > total ? 'Save ' + money(compare - total, cfg.currency) : '';
      $$('[data-rwk-saved]', t).forEach(e => e.textContent = money(Math.max(0, compare - total), cfg.currency));
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(t); } });
    });

    function drawBooks() {
      books.forEach(b => {
        const n = picks.filter(p => p === b.dataset.rwkBook).length;
        b.classList.toggle('is-on', n > 0);
        b.setAttribute('aria-pressed', n > 0 ? 'true' : 'false');
      });
    }
    books.forEach(b => b.addEventListener('click', () => {
      const free = +cur.dataset.free, id = b.dataset.rwkBook;
      if (!free) return;
      const at = picks.indexOf(id);
      if (free === 1) picks = [id];
      else if (at > -1) { if (picks.length > 1) picks.splice(at, 1); }
      else { picks.push(id); while (picks.length > free) picks.shift(); }
      drawBooks();
    }));

    function select(t) {
      cur = t;
      tiers.forEach(x => { x.classList.toggle('is-on', x === t); x.setAttribute('aria-checked', x === t); });
      const lvl = lvlOf(t), free = +t.dataset.free;
      gifts.forEach(g => {
        const open = lvl >= +g.dataset.unlock;
        g.classList.toggle('is-locked', !open);
        $('[data-rwk-gift-p]', g).hidden = !open;
        $('[data-rwk-gift-lock]', g).hidden = open;
        const b = $('b', g); if (b) b.textContent = lvl >= 3 ? b.dataset.t3 : b.dataset.t1;
        const s = $('s', g); if (s) s.textContent = lvl >= 3 ? s.dataset.c3 : s.dataset.c1;
      });
      if (booksBox) {
        booksBox.hidden = !free;
        $('[data-rwk-books-t]', box).textContent = free > 1 ? cfg.booksT3 : cfg.booksT1;
        const rule = $('[data-rwk-books-rule]', box); if (rule) rule.textContent = free > 1 ? cfg.rule3 : cfg.rule2;
        const ids = books.map(b => b.dataset.rwkBook);
        picks = picks.filter(p => ids.indexOf(p) > -1);
        while (picks.length < free) { const next = ids.find(i => picks.indexOf(i) < 0) || ids[0]; picks.push(next); }
        while (picks.length > free) picks.pop();
        drawBooks();
      }
      /* Murphy nur in den Stufen aus upsell.show_on_bars (Gavin 06.10.: in Stufe 2/3 gibt es schon Gratisbuecher) */
      if (upsRow) {
        const on = !Array.isArray(cfg.upsBars) || cfg.upsBars.indexOf(lvl) > -1;
        upsRow.hidden = !on;
        if (!on && ups.checked) ups.checked = false;
      }
      if (wrapRow) {
        const inc = wrapInc(lvl), show = !Array.isArray(cfg.wrapBars) || cfg.wrapBars.indexOf(lvl) > -1 || inc;
        wrapRow.hidden = !show;
        wrapRow.classList.toggle('is-included', inc);
        wrap.disabled = inc;
        if (inc) wrap.checked = true;
        else if (wrap.dataset.auto === '1') wrap.checked = false;
        wrap.dataset.auto = inc ? '1' : '';
        const tt = $('[data-rwk-wrap-t]', box), pp = $('[data-rwk-wrap-p]', box);
        if (tt) tt.textContent = inc ? tt.dataset.inc : tt.dataset.t;
        if (pp) pp.textContent = inc ? pp.dataset.inc : pp.dataset.p;
      }
    }
    select(cur);

    /* Bereich "Das Geschenk": Knopf waehlt Stufe 3 */
    document.addEventListener('click', e => {
      const b = e.target.closest('[data-rwk-pick]');
      if (b && tiers[+b.dataset.rwkPick - 1]) select(tiers[+b.dataset.rwkPick - 1]);
    });

    cta.addEventListener('click', async () => {
      cta.disabled = true;
      const lvl = lvlOf(cur), main = +cur.dataset.main, free = +cur.dataset.free;
      const items = [];
      lineItems(main).forEach(l => items.push({ id: l[0], quantity: l[1] }));
      picks.slice(0, free).forEach(id => items.push({ id: +id, quantity: 1 }));
      if (free > 0 && cfg.ebook) items.push({ id: cfg.ebook, quantity: 1 });
      if (wrapInc(lvl) && cfg.wrapIncluded) items.push({ id: cfg.wrapIncluded, quantity: 1 });
      else if (wrap && wrap.checked && !wrapRow.hidden && cfg.wrapVariant) items.push({ id: cfg.wrapVariant, quantity: 1 });
      if (ups && ups.checked && !(upsRow && upsRow.hidden) && cfg.upsVariant) items.push({ id: cfg.upsVariant, quantity: 1 });
      const merged = {};
      items.forEach(it => { if (it.id) merged[it.id] = (merged[it.id] || 0) + it.quantity; });
      const path = Object.keys(merged).map(id => id + ':' + merged[id]).join(',');
      try {
        const drawer = document.querySelector('cart-drawer');
        await fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } });
        const body = { items: Object.keys(merged).map(id => ({ id: +id, quantity: merged[id] })) };
        if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(s => s.id); body.sections_url = window.location.pathname; }
        const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
        const data = await r.json();
        if (!r.ok || data.status) throw new Error(data.description || 'add failed');
        if (drawer && data.sections && drawer.renderContents) {
          /* Dawn: leerer Drawer traegt is-empty und blendet die Zeilen aus, product-form.js nimmt die Klasse vorher weg (gemessen 06.10.) */
          drawer.classList.remove('is-empty');
          drawer.renderContents(data); cta.disabled = false;
        }
        else window.location.href = root + 'cart';
      } catch (err) {
        window.location.href = root + 'cart/' + path;
      }
    });
    window.addEventListener('pageshow', () => { cta.disabled = false; });

    /* Mobile Sticky-Leiste */
    const sticky = $('[data-rw-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(es => es.forEach(e => sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0)))
        .observe(cta);
    }

    /* Knoepfe "Get 100,000 Whys" springen zum Kaufblock */
    document.addEventListener('click', e => {
      const b = e.target.closest('[data-rw-tobuy]');
      if (!b) return;
      e.preventDefault();
      box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
